import type { OAuthProvider } from './oauthMessages';

export const OAUTH_STATE_TTL_MS = 15 * 60 * 1000;

const createOAuthState = (): string => {
	const bytes = new Uint8Array(32);
	crypto.getRandomValues(bytes);
	return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
		'',
	);
};

const getOAuthStateStorageKey = (provider: OAuthProvider): string =>
	`oauth_state_${provider}`;

export const saveOAuthState = (
	provider: OAuthProvider,
	state: string,
): void => {
	sessionStorage.setItem(
		getOAuthStateStorageKey(provider),
		JSON.stringify({ state, createdAt: Date.now() }),
	);
};

export const clearOAuthState = (provider: OAuthProvider): void => {
	sessionStorage.removeItem(getOAuthStateStorageKey(provider));
};

export const getOAuthStateForProvider = (
	provider: OAuthProvider,
): { state: string; createdAt: number } | null => {
	const stored = sessionStorage.getItem(getOAuthStateStorageKey(provider));
	if (!stored) return null;
	try {
		const parsed = JSON.parse(stored) as { state: string; createdAt: number };
		if (!parsed.state || typeof parsed.createdAt !== 'number') return null;
		return parsed;
	} catch {
		return null;
	}
};

export const isOAuthStateExpired = (createdAt: number): boolean =>
	Date.now() - createdAt > OAUTH_STATE_TTL_MS;

export const initializeOAuthState = (provider: OAuthProvider): string => {
	const state = createOAuthState();
	saveOAuthState(provider, state);
	return state;
};
